import React, { Component } from 'react'
import ReactPaginate from 'react-paginate';
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import MaterialIcon, { colorPalette } from 'material-icons-react';
import EmptyTable from "./EmptyTable";
export default class OgaTable extends Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    render() {
        let loadingClass = this.props.loading ? "loading" : "";
        return (
            <div>
                <div className="oga_table_container">
                    <div>
                        {
                            !this.props.values ?
                                <EmptyTable text={this.props.emptyMessage} /> :

                                this.props.values.length === 0 ? <EmptyTable text="Sin datos" /> :
                                    <table>
                                        <thead>
                                            <tr>
                                                {
                                                    this.props.headers.map((e, i) => {
                                                        let className = this.props.pullRight.includes(i) ? "t-pull-right" : "";
                                                        return (
                                                            <th key={i} className={`column${i} ${className}`}>{e}</th>
                                                        )
                                                    })
                                                }

                                                {
                                                    !this.props.actions ? null : <th className={`column-1`}>Acciones</th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody className={loadingClass}>
                                            {
                                                this.props.values.map((e, i) => {
                                                    let className = "";
                                                    if (this.props.extClass) {
                                                        className += this.props.extClass(e);
                                                    }

                                                    return (
                                                        <tr key={i} className={className}>
                                                            {
                                                                this.props.properties.map((d, i) => {
                                                                    let className = this.props.pullRight.includes(i) ? "t-pull-right" : "";
                                                                    let content = e[d];
                                                                    if (this.props.format) {
                                                                        this.props.format.map(f => {
                                                                            if (f.range === i) {
                                                                                content = f.parse(e[d]);
                                                                            }
                                                                        });
                                                                    }
                                                                    return <td key={i} data-label={this.props.headers[i]} className={`column${i} ${className}`}>{content}</td>
                                                                })
                                                            }

                                                            {
                                                                !this.props.actions ? null :
                                                                    <td data-label="ACCIONES" className={"t-pull-right"}>
                                                                        {
                                                                            this.props.actions.map((action, i) => {
                                                                                const show = action.show == undefined || action.show(e) ? true : false;
                                                                                return (
                                                                                    show &&
                                                                                    <Button key={i} bsSize="small"
                                                                                        data-toggle="tooltip"
                                                                                        data-placement="top"
                                                                                        title={action.tooltip ? action.tooltip(e) : ""}
                                                                                        className="bg-transparent"
                                                                                        onClick={() => action.handler(e)}>
                                                                                        <MaterialIcon size="18px" icon={action.icon} />
                                                                                    </Button>
                                                                                )
                                                                            })
                                                                        }
                                                                    </td>
                                                            }
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                        }
                    </div>
                    {
                        !this.props.loading ? <div className="oga_table_loader_hide" /> : <div className="oga_table_loader" />
                    }
                </div>

                {
                    !this.props.pageCount ? null :
                        <div className="w-100 clearfix">
                            <nav className="float-right">
                                <ReactPaginate previousLabel={"Anterior"}
                                    nextLabel={"Siguiente"}
                                    breakLabel={<a className="disabled">...</a>}
                                    breakClassName={"page-link"}
                                    pageCount={this.props.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={3}
                                    pageClassName={"page-item"}
                                    previousClassName={"page-item"}
                                    previousLinkClassName={"page-link"}
                                    nextClassName={"page-item"}
                                    nextLinkClassName={"page-link"}
                                    pageLinkClassName="page-link"
                                    onPageChange={(data) => this.props.onPageChange(data.selected)}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"page-item"}
                                    activeClassName={"active"} />
                            </nav>
                        </div>
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/OgaTables/OgaTable.jsx